import { toast } from "react-toastify";
import { poAknowledgeEmailTemplate } from "../email-templates/templateGenerator";
import { getUser } from "../services/authService";
import {
  addEmailLog,
  getCCMailFromDB,
  shouldMailSendToSupplier,
  updateActionStatus,
} from "../services/dataService";
import { sendEmail } from "../services/emailService";
import { LATESTACTION_UPDATED } from "../store/ActionType";
import { dispatcher } from "../store/helper";
import { today } from "./dateManager";
import moment from "moment";
import config from "../config/envConfig";
import {
  devCCEmails,
  devToEmails,
  poAcceptanceCCMailLive,
  poAcceptanceToMailLive,
} from "../config/emailRecipient";

export const PO_NEW = "New";
export const PO_UPDATED = "Updated";
export const PO_VIEWED = "Viewed";
export const PO_ACCEPTED = "Accepted";
export const PO_REJECTED = "Rejected";
export const CARGO_READY = "Cargo Ready";
export const PO_COMPLETED = "Completed";

const user = getUser();

export const poStatusHandler = async (purchaseOrder, action, poDetails) => {
  try {
    await updateActionStatus(purchaseOrder, action);
    dispatcher(LATESTACTION_UPDATED, {
      POID: purchaseOrder.POID,
      LatestAction: action,
    });
    const shouldMailSend = await shouldMailSendToSupplier(purchaseOrder.POID);
    if (action === PO_ACCEPTED) {
      toast.success("PO acknowledged");
      if (shouldMailSend) {
        const response = await getCCMailFromDB({
          params: { SendTo: "Impex" },
        });
        const bccMail = response.data?.BCCMail?.split(",");
        const podate = moment(purchaseOrder?.PODate).format("MMM YY");
        await sendEmail({
          receiverAddress: (config.env === "development"
            ? devToEmails
            : poAcceptanceToMailLive),
          cc: (config.env === "development"
            ? devCCEmails
            : poAcceptanceCCMailLive),
          bcc: bccMail,
          receiverName: "Impex Team",
          subject: `${user.userDetails.SupplierShortName}-${purchaseOrder.PONumber}/${podate} - Purchase Order Acceptance mail`,
          HTML: poAknowledgeEmailTemplate(purchaseOrder, poDetails),
          attachments: [],
          templateId: "2",
          alertTime: today(true),
        });
        await addEmailLog({
          Mailto: devToEmails,
          MailCc: devToEmails,
          MailSubject: `${user.userDetails.SupplierShortName}-${purchaseOrder.PONumber}/${podate} - Purchase Order Acceptance mail`,
          FormName: "Purchace Order Acceptance",
          FunctionalityName: "Purchase order dialog ",
          TriggerDatetime: today(true),
          UId: user.userDetails.UserId,
          HostName: "Test HostName",
          ProjectName: "ImpexPortal",
        });
      }
    } else if (action === PO_REJECTED) toast.warning("PO rejected");
  } catch (error) {
    toast.error("Issue accured");
  }
};
